/** Discord user ids are snowflakes; local players (`pnpm dev`) have made-up ids and no profile. */
const SNOWFLAKE = /^\d{17,20}$/;

/**
 * A player's Discord profile (decision 151): friends across servers are made there, not in the
 * game. Null when the id is not a Discord user.
 */
export function discordProfileUrl(userId: string): string | null {
  return SNOWFLAKE.test(userId) ? `https://discord.com/users/${userId}` : null;
}
